module.exports = __webpack_public_path__ + "static/media/yt-uk-drunk-dancing.d3543286.mov";